import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import CardIcon from './CardIcon'
import ValidatedInput from '../ValidatedInput'
import {
  ErrorComponent,
  SuccessComponent,
  NeutralErrorComponent
} from '../DefaultTooltipComponents'
import { getCardType } from '../../InputCard/utils/format'
import styles from './validatedCardInput.module.scss'

const ValidatedCardInput = React.forwardRef(
  (
    {
      message,
      rules,
      header,
      error,
      value,
      showErrorAsNeutral,
      successIcon,
      errorIcon,
      ...restProps
    },
    ref
  ) => {
    const [cardType, setCardType] = useState('')

    useEffect(() => {
      const card = getCardType(value)
      if (card.cardType) {
        setCardType(card.cardType)
      }
    }, [value])

    const vRules = rules || []
    return (
      <div className={styles.container}>
        <ValidatedInput
          ErrorComponent={
            showErrorAsNeutral === true
              ? NeutralErrorComponent({ successIcon, errorIcon })
              : ErrorComponent({ successIcon, errorIcon })
          }
          SuccessComponent={SuccessComponent({ successIcon, errorIcon })}
          rules={vRules}
          type='text'
          ref={ref}
          header={!error && header}
          error={error}
          showErrorAsNeutral={showErrorAsNeutral}
          initValue={value || ""}
          {...restProps}
        />
        <div className={styles.cardIcon}>
          <CardIcon type={cardType} />
        </div>
      </div>
    )
  }
)

ValidatedCardInput.propTypes = {
  message: PropTypes.shape({
    upperAndLower: PropTypes.string,
    digits: PropTypes.string,
    minLength: PropTypes.string
  }),
  rules: PropTypes.arrayOf(
    PropTypes.shape({
      match: PropTypes.func,
      successMessage: PropTypes.string,
      errorMessage: PropTypes.string
    })
  )
}

export default ValidatedCardInput
